import React from 'react';
import { useTranslation } from 'react-i18next';
import { FIELD_LABELS } from '../../../../constants/BookingViewConstants';
import {
  SlotRowContainer,
  SlotRowField,
  SlotRowLabel,
  SlotRowValue,
} from './BookingView.styles';
import { SlotDetail } from './BookingView.types';

interface BookingSlotDetailRowProps {
  slot: SlotDetail;
  isContextual: boolean;
}

const BookingSlotDetailRow: React.FC<BookingSlotDetailRowProps> = ({
  slot,
  isContextual,
}) => {
  const { t } = useTranslation();

  const labels = isContextual
    ? FIELD_LABELS.CONTEXTUAL
    : FIELD_LABELS.NON_CONTEXTUAL;

  const fieldConfigs = [
    { label: labels.NODE, value: slot.contextualNode },
    { label: labels.IMPRESSIONS, value: slot.impressionsBooked },
    { label: labels.IMPRESSIONS_ALLOCATED, value: slot.impressionsAllocated },
    { label: labels.IMPRESSIONS_WAITLISTED, value: slot.impressionsWaitlisted },
    { label: labels.VALUE_BLOCKED, value: slot.valueBlocked },
    { label: labels.SOV, value: `${slot.sovPercentage}%` },
  ];
  return (
    <SlotRowContainer>
      {fieldConfigs.map((field) => (
        <SlotRowField key={field.label}>
          <SlotRowLabel>{t(field.label)}</SlotRowLabel>
          <SlotRowValue>{field.value}</SlotRowValue>
        </SlotRowField>
      ))}
    </SlotRowContainer>
  );
};

export default BookingSlotDetailRow;
